import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightBulb = (props) => /* @__PURE__ */ _jsx("svg", {
	baseProfile: "basic",
	id: "Light_Bulb",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_7267",
		transform: "translate(0.764 1.639)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5677",
				children: /* @__PURE__ */ _jsx("path", { d: "M14.3,14.5H8.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h6.1c0.5,0,0.9,0.4,0.9,0.9C15.2,14.1,14.8,14.5,14.3,14.5z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5678",
				children: /* @__PURE__ */ _jsx("path", { d: "M11.7,20.5h-1c-1.9,0-3.4-1.5-3.4-3.4v-2.8c0,0-0.1-0.1-0.1-0.1C5.7,13,4.6,11.4,4.3,9.5C4,7.7,4.4,5.8,5.5,4.3 c2.2-3.2,6.6-3.9,9.8-1.7c1.5,1.1,2.6,2.7,2.9,4.5c0.3,1.8-0.1,3.7-1.2,5.2c-0.5,0.7-1,1.2-1.7,1.7l-0.1,3 C15.2,18.9,13.6,20.5,11.7,20.5z M8.2,12.6C8.7,13,9,13.6,9,14.2V17c0,0.9,0.8,1.7,1.7,1.7h1c0.9,0,1.7-0.8,1.7-1.7v-2.8 c0-0.6,0.3-1.2,0.9-1.6c0.5-0.3,0.9-0.8,1.2-1.3c0.8-1.2,1.1-2.5,0.9-3.9c-0.2-1.4-1-2.6-2.2-3.4c-2.4-1.7-5.7-1.1-7.3,1.3 C5.3,7.7,5.8,10.9,8.2,12.6z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5679",
				children: /* @__PURE__ */ _jsx("path", { d: "M19.4,4.1c-0.2,0-0.5-0.1-0.6-0.3c-0.3-0.3-0.3-0.9,0-1.2L20,1.4c0.3-0.3,0.9-0.3,1.2,0s0.3,0.9,0,1.2L20,3.8 C19.9,4,19.7,4.1,19.4,4.1z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5680",
				children: /* @__PURE__ */ _jsx("path", { d: "M1.8,15.5c-0.2,0-0.5-0.1-0.6-0.3c-0.3-0.3-0.3-0.9,0-1.2l1.2-1.2c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2l-1.2,1.2 C2.3,15.5,2,15.5,1.8,15.5z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5681",
				children: /* @__PURE__ */ _jsx("path", { d: "M4.1,3.1C3.8,3.1,3.6,3,3.4,2.8L2.2,1.6c-0.3-0.3-0.3-0.9,0-1.2s0.9-0.3,1.2,0l1.2,1.2C5,1.9,5,2.5,4.7,2.8 C4.5,3,4.3,3.1,4.1,3.1z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5682",
				children: /* @__PURE__ */ _jsx("path", { d: "M20.6,15.5c-0.2,0-0.5-0.1-0.6-0.3l-1.2-1.2c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0l1.2,1.2c0.3,0.3,0.3,0.9,0,1.2 C21.1,15.5,20.9,15.5,20.6,15.5z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5683",
				children: /* @__PURE__ */ _jsx("path", { d: "M22.2,9.2h-1.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h1.7c0.5,0,0.9,0.4,0.9,0.9S22.7,9.2,22.2,9.2z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5684",
				children: /* @__PURE__ */ _jsx("path", { d: "M2,9.2H0.3c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H2c0.5,0,0.9,0.4,0.9,0.9S2.5,9.2,2,9.2z" })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Path_5685",
				children: /* @__PURE__ */ _jsx("path", { d: "M14.2,17.4h-6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h6c0.5,0,0.9,0.4,0.9,0.9S14.7,17.4,14.2,17.4z" })
			})
		]
	})
});
export default SvgLightBulb;
